import { render, staticRenderFns } from "./VueEmailMessageTemplates.vue?vue&type=template&id=7c2cb972"
import script from "./VueEmailMessageTemplates.vue?vue&type=script&lang=js"
export * from "./VueEmailMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports